import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceMessageLogs = _resolveComponent("DeviceMessageLogs")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.message_logs', {'device_name': _ctx.logsModalDevice?.name}),
    "dialog-class": "modal-xl",
    modelValue: _ctx.logsModalDevice !== null,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($event === false && (_ctx.logsModalDevice = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DeviceMessageLogs, {
        device: _ctx.logsModalDevice!
      }, null, 8, ["device"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.logsModalDevice = null), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}